import deviceTypes from "@/device-types";
export default {
	mostRecentToasts(state) {
		return state.toasts;
	},

	apiUrl(state) {
		return state.apiUrl;
	},

	mqttCredentials(state) {
		const res = state.credentials.mqtt;
		if (Object.prototype.hasOwnProperty.call(res, "RetCode") && res.RetCode < 0)
			return {};
		return res;
	},

	mqttSubscriptions(state) {
		const res = state.mqtt.subscriptions;
		return res;
	},

	breadcrumbsOpened(state) {
		return state.breadcrumbsOpened;
	},

	isLoggedIn(state) {
		return state.user.username ? true : false;
	},

	currentUsername(state) {
		if (state.user && "username" in state.user) return state.user.username;
		return null;
	},

	currentUserPrimaryClientId(state) {
		if (state.user.primaryClientId) return state.user.primaryClientId;
		return 0;
	},

	currentUserHasRole(state) {
		return role => {
			if (!state.user.roles) return false;
			return state.user.roles.indexOf(role) !== -1;
		};
	},

	currentUserHasFeature(state) {
		return feature => {
			if (!state.user.features) return false;
			return state.user.features.indexOf(feature) !== -1;
		};
	},

	scrEdit(state) {
		if (!state.user.roles) return false;
		// for (var i in deviceTypes) {
		// 	var e = "SCR" + deviceTypes[i].shortName + "edit";
		// 	if (state.user.roles.indexOf(e) !== -1) return true;
		// }
		var e = "SCRTSedit";
		if (state.user.roles.indexOf(e) !== -1) return true;
		return false;
	},

	deviceScrEdit(state) {
		if (!state.user.roles) return false;
		for (var i in deviceTypes) {
			var e = "SCR" + deviceTypes[i].shortName + "edit";
			if (state.user.roles.indexOf(e) !== -1) return true;
		}

		return false;
	},
	mapZoom(state) {
		return state.map.zoom;
	},

	mapCenter(state) {
		return state.map.center;
	},

	replaceLabel(state) {
		return labelText => {
			labelText = labelText.trim();
			let replaceText = labelText;
			const labelIndex = labelText.toUpperCase();
			const mappings = state.user.labelMappings;

			if (mappings[labelIndex]) {
				const thisLabel = mappings[labelIndex];
				if (thisLabel.ExactMatch === true && thisLabel.LabelText == labelText) {
					replaceText = thisLabel.ReplaceText;
				} else if (thisLabel.ExactMatch === false) {
					replaceText = thisLabel.ReplaceText;
				}
			}
			return replaceText;
		};
	}
};
